export enum categorieEnginTypes {
    LOADING = "LOADING",
    SELECTED_CATEGORIE_ENGIN = "SELECTED_CATEGORIE_ENGIN",
    GET_CATEGORIE_ENGIN_LIST = "GET_CATEGORIE_ENGIN_LIST",
}
  
export default categorieEnginTypes;